<template>
    <div class="home-service">
        <div class="title">
            <span>Servicios</span>
            <h1>para empresa y personas</h1>
        </div>
        <div class="services">
            <center>
                <h1>Conoce nuestras soluciones</h1>
                <div v-for="(slide, i) in slides" :key="i">
                    <div v-for="(service, y) in slide.service" :key="y">
                        <div class="service">
                            <div>
                                <div>
                                    <h5 v-html="service.text"></h5>
                                    <button @click="$router.push('/servicios/' + service.route)">VER MÁS</button>
                                </div>
                                <img :src="service.img" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </center>
        </div>
        <Conecta/>
    </div>
</template>

<script>
import Conecta from '../utilitis/conecta'

export default {
    name: 'HomeService',
    components: {
        Conecta
    },
    beforeMount() {
        this.$root.$emit('change_url', this.$route.name)
    },
    data() {
        return {
            slides: [
                {
                    service: [
                        {
                            text: 'Seguros <br> ARL',
                            img: require('@/assets/servicios/1.png'),
                            route: 'arl'
                        },
                        {
                            text: 'Seguros <br> Empresariales',
                            img: require('@/assets/servicios/2.png'),
                            route: 'empresas'
                        },
                        {
                            text: 'Seguros Personales <br> y Familia',
                            img: require('@/assets/servicios/3.png'),
                            route: 'personas'
                        }
                    ]
                }
            ]
        }
    }
}
</script>

<style scoped>
    .title {
        background-image: url('../../assets/servicios-bg.png');
        padding: 100px 300px;
    }
    .title > span {
        font-family: 'JLI';
        font-size: 40px;
        color: #fff;
    }
    .title > h1 {
        font-family: 'JBD';
        color: #fff;
        font-size: 60px;
        margin-bottom: 50px;
    }
    .services > center {
        display: contents;
    }
    .services > center > div {
        margin-top: 100px;
        display: inline-block;
        width: 100%;
        padding: 0px 300px;
    }
    .services > center > h1 {
        margin-top: 100px;
        font-family: 'JBD';
        color: #2d4f98;
    }
    .services > center > div > p {
        text-align: left;
        color: #65b24a;
        font-family: 'JBD';
        margin-left: 25px;
        font-size: 25px;
    }
    .services > center > div > div {
        display: inline-flex;
        width: 33.333333333%;
        float: left;
    }
    .services > center > div > div > .service {
        width: 100%;
    }
    .services > center > div > div > .service > div {
        position: relative;
        width: 95%;
        height: 100%;
        padding: auto;
        margin-bottom: 35px;
        transition: margin-top .5s ease-out 100ms;
    }
    .services > center > div > div > .service > div:hover {
        margin-top: -10px;
    }
    .services > center > div > div > .service > div >  img {
        width: 100%;
        height: auto;
    }
    .services > center > div > div > .service > div > div {
        position: absolute;
        color: #fff;
        padding-top: 120px;
        padding-left: 25px;
        height: auto;
    }
    .services > center > div > div > .service > div > div > h5 {
        font-family: 'JBD';
        color: #fff;
        text-align: left;
    }
    .services > center > div > div > .service > div > div > button {
        font-family: 'JR';
        background-color: #65b24a;
        width: 114px;
        height: auto;
        padding: 0px 30px;
        border-radius: 20px;
        border-color: #65b24a;
        border-style: solid;
        font-size: 12px;
        color: #fff;
        position: absolute;
        left: 25px;
    }
    .services > center > div > div > .service > div > div > button:hover {
        background-color: #2d4f98;
    }
    @media (max-width: 1500px) {
        .services > center > div {
            padding: 0px 200px;
        }
    }
    @media (max-width: 1300px) {
        .services > center > div {
            padding: 0px 100px;
        }
    }
    @media (max-width: 1100px) {
        .title > span {
            font-size: 30px;
        }
        .title > h1 {
            font-size: 50px;
        }
    }
    @media (max-width: 1000px) {
        .services > center > div {
            padding: 0px 25px;
        }
    }
    @media (max-width: 900px) {
        .services > center > div > div > .service > div > div {
            padding-top: 60px;
        }
        .title {
            padding: 100px 200px;
        }
    }
    @media (max-width: 700px) {
        .services > center > div > div {
            display: block;
            width: 60%;
            float: none;
        }
        .services > center > div > div > .service > div > div {
            padding-top: 120px;
        }
        .title {
            padding: 100px 100px;
        }
    }
    @media (max-width: 600px) {
        .services > center > div > div > .service > div > div {
            padding-top: 90px;
        }
        .services > center > div > div {
            display: block;
            width: 70%;
            float: none;
        }
    }
    @media (max-width: 500px) {
        .services > center > div > div {
            display: block;
            width: 80%;
            float: none;
        }
        .services > center > div > div > .service > div > div {
            padding-top: 90px;
        }
    }
    @media (max-width: 500px) {
        .services > center > div > div {
            display: block;
            width: 90%;
            float: none;
        }
        .services > center > div > div > .service > div > div {
            padding-top: 80px;
        }
        .title > span {
            font-size: 30px;
        }
        .title > h1 {
            font-size: 40px;
        }
    }
    @media (max-width: 500px) {
        .title > span {
            text-align: left;
            padding-left: 25px;
        }
        .title > h1 {
            text-align: left;
            padding-left: 25px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Servicios/HomeService.vue